import {Component, OnInit, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import {EnergyService} from '../../services/energy.service';
import {EnergyModel} from '../../model/EnergyModel';
import {NgbDateStruct, NgbInputDatepicker, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DateUtil} from '../../util/DateUtil';
import {ChartConfiguration, ChartData, ChartType} from 'chart.js';
import {ArrayUtils} from '../../util/ArrayUtils';
import {BaseChartDirective} from 'ng2-charts';
import {FormsModule} from '@angular/forms';

@Component({
    selector: 'app-energy',
    templateUrl: './energy.component.html',
    styleUrls: ['./energy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [BaseChartDirective, FormsModule, NgbInputDatepicker]
})
export class EnergyComponent implements OnInit {


  energyEntries: EnergyModel[];
  energyEntriesPerDay: EnergyEntriesAndDay[];
  currentEntry: EnergyModel;

  public pieChartType: ChartType = 'pie';
  public pieChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    plugins: {
      legend: {
        position: 'right',
      },
    }
  };

  constructor(
    private energyService: EnergyService,
    private modalService: NgbModal
  ) {
  }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.energyService.getAllEnergyEntries().subscribe((res: EnergyModel[]) => {
      this.energyEntries = res;
      this.energyEntriesPerDay = [];



      res.forEach(entry => {
        if (this.energyEntriesPerDay.length === 0 || ArrayUtils.last(this.energyEntriesPerDay).day !== (entry.date as string)) {
          this.energyEntriesPerDay.push({day: entry.date as string, entries: [], chartData: {
              labels: [],
              datasets: [{data: []}]
            }
          });
        }
        ArrayUtils.last(this.energyEntriesPerDay).entries.push(entry);
        ArrayUtils.last(this.energyEntriesPerDay).chartData.datasets[0].data.push(entry.effort);
        ArrayUtils.last(this.energyEntriesPerDay).chartData.labels.push(entry.description);
      });

    });
  }

  selectNew(content: TemplateRef<unknown>) {
    this.currentEntry = {} as EnergyModel;
    this.currentEntry.date = DateUtil.getToday();

    this.openModal(content);
  }

  openModal(content: TemplateRef<unknown>) {

    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'})
      .result.then(() => this.save());
  }

  select(row: EnergyModel, content: TemplateRef<unknown>) {
    this.currentEntry = {...row};
    this.currentEntry.date = DateUtil.stringToNgb(this.currentEntry.date as string);

    this.openModal(content);
  }

  save() {
    const energyModel = {...this.currentEntry};
    energyModel.date = DateUtil.ngbToString((energyModel.date) as NgbDateStruct);
    this.energyService.save(energyModel).subscribe(res => {
      this.getData();
    });
  }

  dayToWeekDay(day: string): string {
   return DateUtil.dayToWeekDay(day);
  }
}

export interface EnergyEntriesAndDay {
  day: string;
  entries: EnergyModel[];

  chartData: ChartData<'pie', number[], string | string[]>;
}
